import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';

import { environment } from '../../environments/environment';
import { Diagnosis } from './diagnosis';
import { requestHeaders, handleError } from '../shared/api.service';

const decamelizeKeysDeep = require('decamelize-keys-deep');

@Injectable()
export class DiagnosisService {
  baseUrl = environment.serverUrl;
  params: URLSearchParams = new URLSearchParams();
  public nextUri;
  public count = 0;

  constructor(private http: Http) {
    this.params = new URLSearchParams();
  }

  getDiagnoses(query: any = null): Observable<Diagnosis[]> {
    if (query) {
      Object.keys(query).forEach((key) => {
        if (typeof query[key] !== 'undefined' && query[key] && query[key].toString) {
          this.params.set(key, query[key].toString());
        }
      });
    }
    this.params.set('sf', 'code,name');

    let diagnosesUrl = 'https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search';
    return this.http.get(diagnosesUrl, {
      headers: requestHeaders(),
      search: this.params
    }).map(res => {
      return this.extractData(res);
    });
  }

  private extractData(res: Response) {
    let resObj = res.json();
    this.nextUri = resObj.next;
    this.count = resObj.count;
    let body = resObj[3]; // Element three is the payload
    if (body) {
      return body.map(diagnosis => {
        return new Diagnosis(diagnosis);
      });
    } else if (resObj) {
      return new Diagnosis(resObj);
    } else {
      return {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/diagnoses/diagnosis.service.ts